import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { 
  Mic, 
  MicOff, 
  X, 
  ChevronLeft,
  ChevronRight,
  BookOpen, 
  Sun, 
  SquareStack, 
  Heart, 
  Briefcase, 
  Hash, 
  Hand, 
  Eye, 
  Compass, 
  Scroll, 
  Activity, 
  Home,
  Stethoscope,
  Shield,
  Users as FamilyIcon,
  
  Building2,
  FileText,
  Globe,
  Lightbulb,
  Key,
  Award,
  Search,
  Car,
  HeartPulse,
  Baby,
  Bone,
  Brain,
  Smile,
  ShieldAlert,
  DollarSign,
  ShieldCheck,
  GraduationCap,
  type LucideIcon 
} from 'lucide-react'; 
import { useSpeechRecognition } from '../../hooks/useSpeechRecognition'; 

export interface SubCategoryItem {
  id: number;
  label: string;
  slug: string;
  icon: LucideIcon;
  badge?: string;
  hoverClass: string;
  activeClass: string;
}

// 🟢 COMPLETE MAP OF ALL 38 DATABASE SUBCATEGORIES (SkillYatriDB)
const SUBCATEGORIES_MAP: Record<string, SubCategoryItem[]> = {

  // ============================================================================
  // 🔮 CATEGORY 1: ASTROLOGY SUBCATEGORIES (IDs: 1 - 12)
  // ============================================================================
  astrology: [
    {  
      id: 3, 
      label: 'Love & Relationship Astrology', 
      slug: 'love-and-relationship-astrology', 
      icon: Heart, 
      badge: 'Popular',
      hoverClass: 'hover:border-rose-300 hover:text-rose-600 hover:bg-rose-50/60',
      activeClass: 'bg-gradient-to-r from-rose-500 via-pink-500 to-rose-600 text-white shadow-lg shadow-rose-500/25 border-transparent'
    },
    { 
      id: 4, 
      label: 'Career & Business Astrology Experts', 
      slug: 'career-and-business-astrology', 
      icon: Briefcase, 
      badge: 'Trending',
      hoverClass: 'hover:border-amber-300 hover:text-amber-600 hover:bg-amber-50/60',
      activeClass: 'bg-gradient-to-r from-amber-500 via-orange-500 to-amber-600 text-white shadow-lg shadow-amber-500/25 border-transparent'
    },
    { 
      id: 1, 
      label: 'Vedic Astrologers', 
      slug: 'vedic-astrology', 
      icon: Sun,
      hoverClass: 'hover:border-blue-300 hover:text-blue-600 hover:bg-blue-50/60',
      activeClass: 'bg-gradient-to-r from-blue-600 via-indigo-600 to-blue-700 text-white shadow-lg shadow-blue-500/25 border-transparent'
    },
    { 
      id: 2, 
      label: 'Tarot Card Readers', 
      slug: 'tarot-card-readers', 
      icon: SquareStack,
      hoverClass: 'hover:border-purple-300 hover:text-purple-600 hover:bg-purple-50/60',
      activeClass: 'bg-gradient-to-r from-purple-600 via-fuchsia-600 to-purple-700 text-white shadow-lg shadow-purple-500/25 border-transparent'
    },
    { 
      id: 9, 
      label: 'Lal Kitab Experts', 
      slug: 'lal-kitab-experts', 
      icon: BookOpen,
      hoverClass: 'hover:border-red-300 hover:text-red-600 hover:bg-red-50/60',
      activeClass: 'bg-gradient-to-r from-red-600 via-rose-600 to-red-700 text-white shadow-lg shadow-red-500/25 border-transparent'
    },
    { 
      id: 5, 
      label: 'Numerologists', 
      slug: 'numerologists', 
      icon: Hash,
      hoverClass: 'hover:border-cyan-300 hover:text-cyan-600 hover:bg-cyan-50/60',
      activeClass: 'bg-gradient-to-r from-cyan-600 via-teal-600 to-cyan-700 text-white shadow-lg shadow-cyan-500/25 border-transparent'
    },
    { 
      id: 6, 
      label: 'Palmists (Hast Rekha Experts)', 
      slug: 'palmists', 
      icon: Hand,
      hoverClass: 'hover:border-emerald-300 hover:text-emerald-600 hover:bg-emerald-50/60',
      activeClass: 'bg-gradient-to-r from-emerald-600 via-green-600 to-teal-600 text-white shadow-lg shadow-emerald-500/25 border-transparent'
    },
    { 
      id: 7, 
      label: 'Face Reading Experts (Samudrik Shastra)', 
      slug: 'face-reading-experts', 
      icon: Eye,
      hoverClass: 'hover:border-violet-300 hover:text-violet-600 hover:bg-violet-50/60',
      activeClass: 'bg-gradient-to-r from-violet-600 via-purple-600 to-indigo-600 text-white shadow-lg shadow-violet-500/25 border-transparent'
    },
    { 
      id: 8, 
      label: 'Western Astrologers', 
      slug: 'western-astrologers', 
      icon: Compass,
      hoverClass: 'hover:border-sky-300 hover:text-sky-600 hover:bg-sky-50/60',
      activeClass: 'bg-gradient-to-r from-sky-600 via-blue-600 to-indigo-600 text-white shadow-lg shadow-sky-500/25 border-transparent'
    },
    { 
      id: 10, 
      label: 'Nadi Astrologers', 
      slug: 'nadi-astrologers', 
      icon: Scroll,
      hoverClass: 'hover:border-orange-300 hover:text-orange-600 hover:bg-orange-50/60',
      activeClass: 'bg-gradient-to-r from-orange-600 via-amber-600 to-orange-700 text-white shadow-lg shadow-orange-500/25 border-transparent'
    },
    { 
      id: 11, 
      label: 'Health Astrology', 
      slug: 'health-astrology', 
      icon: Activity,
      hoverClass: 'hover:border-emerald-300 hover:text-emerald-600 hover:bg-emerald-50/60',
      activeClass: 'bg-gradient-to-r from-emerald-500 via-teal-500 to-emerald-600 text-white shadow-lg shadow-emerald-500/25 border-transparent'
    },
    { 
      id: 12, 
      label: 'Remedies & Vastu Consultants', 
      slug: 'remedies-and-vastu-consultants', 
      icon: Home,
      hoverClass: 'hover:border-amber-300 hover:text-amber-700 hover:bg-amber-50/60',
      activeClass: 'bg-gradient-to-r from-amber-600 via-yellow-600 to-orange-600 text-white shadow-lg shadow-amber-500/25 border-transparent'
    },
  ],

  // ============================================================================
  // ⚖️ CATEGORY 2: LAWYER SUBCATEGORIES (IDs: 13 - 27)
  // ============================================================================
  lawyer: [
    { 
      id: 13, 
      label: 'Family and Marriage Law', 
      slug: 'family-law', 
      icon: FamilyIcon,
      badge: 'Trending',
      hoverClass: 'hover:border-indigo-300 hover:text-indigo-600 hover:bg-indigo-50/60',
      activeClass: 'bg-gradient-to-r from-indigo-600 to-blue-700 text-white shadow-lg shadow-indigo-500/25 border-transparent'
    },
    { 
      id: 18, 
      label: 'Consumer Protection Law', 
      slug: 'consumer-protection-law', 
      icon: ShieldCheck,
      badge: 'Popular',
      hoverClass: 'hover:border-blue-300 hover:text-blue-600 hover:bg-blue-50/60',
      activeClass: 'bg-gradient-to-r from-blue-600 to-cyan-600 text-white shadow-lg shadow-blue-500/25 border-transparent'
    },
    { 
      id: 14, 
      label: 'Criminal Law', 
      slug: 'criminal-defense', 
      icon: ShieldAlert,
      hoverClass: 'hover:border-slate-400 hover:text-slate-800 hover:bg-slate-100',
      activeClass: 'bg-gradient-to-r from-slate-800 to-slate-950 text-white shadow-lg shadow-slate-900/25 border-transparent'
    },
    { 
      id: 15, 
      label: 'Business Law', 
      slug: 'business-law', 
      icon: Building2,
      hoverClass: 'hover:border-slate-300 hover:text-slate-700 hover:bg-slate-50',
      activeClass: 'bg-gradient-to-r from-slate-700 to-slate-900 text-white shadow-lg shadow-slate-600/25 border-transparent'
    },
    { 
      id: 16, 
      label: 'Real Estate Law', 
      slug: 'real-estate-law', 
      icon: Home,
      hoverClass: 'hover:border-emerald-300 hover:text-emerald-700 hover:bg-emerald-50/60',
      activeClass: 'bg-gradient-to-r from-emerald-600 to-teal-700 text-white shadow-lg shadow-emerald-500/25 border-transparent'
    },
    { 
      id: 17, 
      label: 'Bankruptcy Law', 
      slug: 'bankruptcy-law', 
      icon: DollarSign,
      hoverClass: 'hover:border-rose-300 hover:text-rose-600 hover:bg-rose-50/60',
      activeClass: 'bg-gradient-to-r from-rose-600 to-red-700 text-white shadow-lg shadow-rose-500/25 border-transparent'
    },
    { 
      id: 19, 
      label: 'Education Law', 
      slug: 'education-law', 
      icon: GraduationCap,
      hoverClass: 'hover:border-sky-300 hover:text-sky-600 hover:bg-sky-50/60',
      activeClass: 'bg-gradient-to-r from-sky-600 to-blue-600 text-white shadow-lg shadow-sky-500/25 border-transparent'
    },
    { 
      id: 20, 
      label: 'Employment Law', 
      slug: 'employment-law', 
      icon: Briefcase,
      hoverClass: 'hover:border-amber-300 hover:text-amber-600 hover:bg-amber-50/60',
      activeClass: 'bg-gradient-to-r from-amber-600 to-orange-600 text-white shadow-lg shadow-amber-500/25 border-transparent'
    },
    { 
      id: 21, 
      label: 'Estate Law', 
      slug: 'estate-law', 
      icon: FileText,
      hoverClass: 'hover:border-indigo-300 hover:text-indigo-600 hover:bg-indigo-50/60',
      activeClass: 'bg-gradient-to-r from-indigo-700 to-purple-800 text-white shadow-lg shadow-indigo-500/25 border-transparent'
    },
    { 
      id: 22, 
      label: 'Immigration Law', 
      slug: 'immigration-law', 
      icon: Globe,
      hoverClass: 'hover:border-teal-300 hover:text-teal-600 hover:bg-teal-50/60',
      activeClass: 'bg-gradient-to-r from-teal-600 to-cyan-700 text-white shadow-lg shadow-teal-500/25 border-transparent'
    },
    { 
      id: 23, 
      label: 'Intellectual Property Law', 
      slug: 'intellectual-property-law', 
      icon: Lightbulb,
      hoverClass: 'hover:border-yellow-300 hover:text-yellow-600 hover:bg-yellow-50/60',
      activeClass: 'bg-gradient-to-r from-amber-500 to-yellow-600 text-white shadow-lg shadow-amber-500/25 border-transparent'
    },
    { 
      id: 24, 
      label: 'Landlord-Tenant', 
      slug: 'landlord-tenant', 
      icon: Key,
      hoverClass: 'hover:border-violet-300 hover:text-violet-600 hover:bg-violet-50/60',
      activeClass: 'bg-gradient-to-r from-violet-600 to-purple-700 text-white shadow-lg shadow-violet-500/25 border-transparent'
    },
    { 
      id: 25, 
      label: 'Military Law', 
      slug: 'military-law', 
      icon: Award,
      hoverClass: 'hover:border-stone-400 hover:text-stone-800 hover:bg-stone-100',
      activeClass: 'bg-gradient-to-r from-stone-800 to-neutral-900 text-white shadow-lg shadow-stone-800/25 border-transparent'
    },
    { 
      id: 26, 
      label: 'Personal Inquiry Law', 
      slug: 'personal-inquiry-law', 
      icon: Search,
      hoverClass: 'hover:border-blue-300 hover:text-blue-600 hover:bg-blue-50/60',
      activeClass: 'bg-gradient-to-r from-blue-700 to-indigo-800 text-white shadow-lg shadow-blue-500/25 border-transparent'
    },
    { 
      id: 27, 
      label: 'Traffic Law', 
      slug: 'traffic-law', 
      icon: Car,
      hoverClass: 'hover:border-orange-300 hover:text-orange-600 hover:bg-orange-50/60',
      activeClass: 'bg-gradient-to-r from-orange-600 to-red-600 text-white shadow-lg shadow-orange-500/25 border-transparent'
    },
  ],

  // ============================================================================
  // 🩺 CATEGORY 3: DOCTOR SUBCATEGORIES (IDs: 28 - 46)
  // ============================================================================
  doctor: [
    { 
      id: 45, 
      label: 'General Physician', 
      slug: 'general-physician', 
      icon: Stethoscope,
      badge: 'Popular',
      hoverClass: 'hover:border-teal-300 hover:text-teal-600 hover:bg-teal-50/60',
      activeClass: 'bg-gradient-to-r from-teal-600 to-cyan-600 text-white shadow-lg shadow-teal-500/25 border-transparent'
    },
    { 
      id: 29, 
      label: 'Dermatology', 
      slug: 'dermatology', 
      icon: Activity,
      badge: 'Trending',
      hoverClass: 'hover:border-pink-300 hover:text-pink-600 hover:bg-pink-50/60',
      activeClass: 'bg-gradient-to-r from-pink-600 to-rose-600 text-white shadow-lg shadow-pink-500/25 border-transparent'
    },
    { 
      id: 46, 
      label: 'Gynecology', 
      slug: 'gynecology', 
      icon: Heart,
      hoverClass: 'hover:border-rose-300 hover:text-rose-600 hover:bg-rose-50/60',
      activeClass: 'bg-gradient-to-r from-rose-500 to-pink-600 text-white shadow-lg shadow-rose-500/25 border-transparent'
    },
    { 
      id: 28, 
      label: 'Cardiology', 
      slug: 'cardiology', 
      icon: HeartPulse,
      hoverClass: 'hover:border-red-300 hover:text-red-600 hover:bg-red-50/60',
      activeClass: 'bg-gradient-to-r from-red-600 to-rose-700 text-white shadow-lg shadow-red-500/25 border-transparent'
    },
    { 
      id: 30, 
      label: 'Pediatrics', 
      slug: 'pediatrics', 
      icon: Baby,
      hoverClass: 'hover:border-sky-300 hover:text-sky-600 hover:bg-sky-50/60',
      activeClass: 'bg-gradient-to-r from-sky-500 to-indigo-600 text-white shadow-lg shadow-sky-500/25 border-transparent'
    },
    { 
      id: 32, 
      label: 'Orthopedics', 
      slug: 'orthopedics', 
      icon: Bone,
      hoverClass: 'hover:border-amber-300 hover:text-amber-600 hover:bg-amber-50/60',
      activeClass: 'bg-gradient-to-r from-amber-600 to-orange-600 text-white shadow-lg shadow-amber-500/25 border-transparent'
    },
    { 
      id: 34, 
      label: 'Endocrinology', 
      slug: 'endocrinology', 
      icon: Activity,
      hoverClass: 'hover:border-emerald-300 hover:text-emerald-600 hover:bg-emerald-50/60',
      activeClass: 'bg-gradient-to-r from-emerald-600 to-teal-600 text-white shadow-lg shadow-emerald-500/25 border-transparent'
    },
    { 
      id: 35, 
      label: 'Neurology', 
      slug: 'neurology', 
      icon: Brain,
      hoverClass: 'hover:border-purple-300 hover:text-purple-600 hover:bg-purple-50/60',
      activeClass: 'bg-gradient-to-r from-purple-600 to-indigo-700 text-white shadow-lg shadow-purple-500/25 border-transparent'
    },
    { 
      id: 36, 
      label: 'Oncology', 
      slug: 'oncology', 
      icon: Shield,
      hoverClass: 'hover:border-violet-300 hover:text-violet-600 hover:bg-violet-50/60',
      activeClass: 'bg-gradient-to-r from-violet-600 to-fuchsia-700 text-white shadow-lg shadow-violet-500/25 border-transparent'
    },
    { 
      id: 38, 
      label: 'Urology', 
      slug: 'urology', 
      icon: Activity,
      hoverClass: 'hover:border-cyan-300 hover:text-cyan-600 hover:bg-cyan-50/60',
      activeClass: 'bg-gradient-to-r from-cyan-600 to-blue-600 text-white shadow-lg shadow-cyan-500/25 border-transparent'
    },
    { 
      id: 41, 
      label: 'Dental', 
      slug: 'dental', 
      icon: Smile,
      hoverClass: 'hover:border-blue-300 hover:text-blue-600 hover:bg-blue-50/60',
      activeClass: 'bg-gradient-to-r from-blue-500 to-cyan-600 text-white shadow-lg shadow-blue-500/25 border-transparent'
    },
  ],
};

interface SearchAndFilterProps {
  searchTerm: string;
  setSearchTerm: (val: string) => void;
  activeCategory: string;
  categories?: string[]; 
  onCategoryClick: (category: string) => void;
  loadingCategories?: boolean;
  sortBy?: 'price' | 'rating' | 'experience';
  setSortBy: (val?: 'price' | 'rating' | 'experience') => void;
  sortOrder?: 'ASC' | 'DESC';
  setSortOrder: (val?: 'ASC' | 'DESC') => void;
  minRating?: number;
  setMinRating: (val?: number) => void;
}

export const SearchAndFilter: React.FC<SearchAndFilterProps> = ({
  searchTerm,
  setSearchTerm,
  activeCategory,
  loadingCategories = false,
  sortBy,
  setSortBy,
  sortOrder,
  setSortOrder,
  minRating,
  setMinRating,
}) => {
  const navigate = useNavigate();
  const { subCategorySlug = '' } = useParams<{ subCategorySlug?: string }>();

  const [showFilters, setShowFilters] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  
  // 🟢 REF FOR DESKTOP SCROLLING
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  const { isListening, startListening, stopListening } = useSpeechRecognition({
    onResult: (transcript) => setSearchTerm(transcript),
    onError: (error) => console.error('Speech recognition error:', error)
  });

  const handleVoiceSearch = () => {
    if (isListening) {
      stopListening();
    } else {
      startListening();
    }
  };

  // 🟢 BUTTON CLICK SCROLL HANDLER
  const scroll = (direction: 'left' | 'right') => {
    if (scrollContainerRef.current) {
      const scrollAmount = 320;
      scrollContainerRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });
    }
  };

  // 🟢 MOUSE WHEEL SCROLL TRANSLATOR (Vertical Wheel -> Horizontal Scroll)
  const handleWheel = (e: React.WheelEvent<HTMLDivElement>) => {
    if (scrollContainerRef.current && e.deltaY !== 0) {
      scrollContainerRef.current.scrollLeft += e.deltaY;
    }
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setShowFilters(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const currentCategoryKey = activeCategory.toLowerCase();
  const activeSubCategories = SUBCATEGORIES_MAP[currentCategoryKey] || SUBCATEGORIES_MAP['astrology'];

  return (
    <>
      <style>{`
        @keyframes glow {
          0%, 100% {
            box-shadow: 0 0 20px rgba(236, 72, 153, 0.6), 0 0 40px rgba(168, 85, 247, 0.4);
          }
          50% {
            box-shadow: 0 0 30px rgba(236, 72, 153, 0.8), 0 0 60px rgba(168, 85, 247, 0.6);
          }
        }
      `}</style>
      
      <div className="sticky top-[48px] sm:top-[64px] z-40 bg-gray-50/90 backdrop-blur-md pt-4 md:pt-6 pb-2 px-4 md:px-6 shadow-sm border-b border-gray-200/50">
        <div className="max-w-7xl mx-auto">
          
          {/* SearchBar + Filter Button Container */}
          <div className="flex gap-3 items-center mb-3 relative" ref={dropdownRef}>
            
            {/* Search Bar */}
            <div className="flex-1 flex items-center bg-white rounded-xl px-4 py-3.5 shadow-sm focus-within:ring-2 focus-within:ring-blue-500 transition-all border border-gray-200">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
              
              <input 
                type="text" 
                placeholder={isListening ? "Listening..." : `Search ${activeCategory}...`}
                className="bg-transparent border-none outline-none w-full ml-3 text-gray-800 font-medium placeholder-gray-400 text-sm md:text-base"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />

              {searchTerm && (
                <button 
                  onClick={() => setSearchTerm("")}
                  className="p-1 hover:bg-gray-200 rounded-full transition-colors mr-1 cursor-pointer"
                >
                  <X className="w-4 h-4 text-gray-400" />
                </button>
              )}

              {/* Animated Mic Button */}
              <button 
                onClick={handleVoiceSearch}
                className={`rounded-full transition-all mx-1 flex-shrink-0 cursor-pointer ${
                  isListening 
                    ? 'p-1.5 bg-gradient-to-r from-pink-500 via-purple-500 to-pink-500 shadow-lg shadow-pink-500/50' 
                    : 'p-1.5 bg-gradient-to-r from-purple-400 via-pink-400 to-purple-400 hover:from-pink-500 hover:via-purple-500 hover:to-blue-500 shadow-md shadow-purple-300/40'
                }`}
                title={isListening ? "Stop listening" : "Voice search"}
                style={isListening ? {
                  animation: 'pulse 1.5s ease-in-out infinite, glow 2s ease-in-out infinite'
                } : {}}
              >
                {isListening ? (
                  <MicOff className="w-4 h-4 text-white animate-pulse" />
                ) : (
                  <Mic className="w-4 h-4 text-white" />
                )}
              </button>
            </div>

            {/* Filter Button */}
            <div className="relative">
              <button 
                onClick={() => setShowFilters(!showFilters)}
                className="bg-slate-900 hover:bg-slate-800 text-white px-5 py-3.5 rounded-xl flex items-center justify-center transition-all active:scale-95 cursor-pointer shadow-md"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4" />
                </svg>
                
                {(sortBy || minRating) && (
                  <span className="absolute -top-1 -right-1 flex h-3 w-3">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-rose-400 opacity-75"></span>
                    <span className="relative inline-flex rounded-full h-3 w-3 bg-rose-500 border border-white"></span>
                  </span>
                )}
              </button>

              {/* Filter Dropdown Menu */}
              {showFilters && (
                <div className="absolute right-0 top-full mt-3 w-72 bg-white rounded-2xl shadow-2xl border border-gray-100 p-5 z-50 origin-top-right">
                  <div className="flex justify-between items-center mb-4">
                    <h3 className="font-bold text-gray-900">Filters</h3>
                    <button 
                      onClick={() => { setSortBy(undefined); setSortOrder(undefined); setMinRating(undefined); }}
                      className="text-xs text-blue-600 hover:underline font-semibold cursor-pointer"
                    >
                      Clear All
                    </button>
                  </div>

                  {/* Sort Options */}
                  <div className="mb-5">
                    <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-2">Sort By</label>
                    <select 
                      className="w-full bg-gray-50 border border-gray-200 text-gray-800 rounded-xl p-3 text-sm focus:ring-2 focus:ring-blue-500 outline-none cursor-pointer font-medium"
                      value={`${sortBy || ''}-${sortOrder || ''}`}
                      onChange={(e) => {
                        const val = e.target.value;
                        if (!val || val === '-') {
                          setSortBy(undefined); setSortOrder(undefined);
                        } else {
                          const [by, order] = val.split('-');
                          setSortBy(by as any); setSortOrder(order as any);
                        }
                      }}
                    >
                      <option value="-">Recommended</option>
                      <option value="price-ASC">Price: Low to High</option>
                      <option value="price-DESC">Price: High to Low</option>
                      <option value="rating-DESC">Rating: High to Low</option>
                      <option value="experience-DESC">Experience: High to Low</option>
                    </select>
                  </div>

                  {/* Rating Filter */}
                  <div>
                    <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-2">Minimum Rating</label>
                    <div className="grid grid-cols-4 gap-2">
                      {[undefined, 3, 4, 4.5].map(rating => (
                        <button 
                          key={rating || 'any'}
                          onClick={() => setMinRating(rating)}
                          className={`py-2 rounded-lg text-xs font-bold border transition-colors cursor-pointer ${
                            minRating === rating 
                              ? 'bg-blue-50 text-blue-600 border-blue-200 shadow-sm' 
                              : 'bg-white text-gray-600 border-gray-200 hover:bg-gray-50'
                          }`}
                        >
                          {rating ? `${rating}+` : 'Any'}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* 🟢 SUBCATEGORY PILL BAR WITH DESKTOP ARROW NAVIGATION & MOUSE WHEEL SCROLL */}
          <div className="relative group py-2">
            
            {/* LEFT ARROW BUTTON (Visible on PC hover) */}
            <button
              onClick={() => scroll('left')}
              className="hidden md:flex absolute left-0 top-1/2 -translate-y-1/2 z-20 w-8 h-8 items-center justify-center rounded-full bg-white/90 shadow-md border border-gray-200 text-gray-700 hover:bg-white hover:scale-110 opacity-0 group-hover:opacity-100 transition-all duration-200 cursor-pointer"
              title="Scroll Left"
            >
              <ChevronLeft className="w-5 h-5" />
            </button>

            {/* SCROLLABLE PILLS CONTAINER */}
            <div 
              ref={scrollContainerRef}
              onWheel={handleWheel}
              className="flex gap-2.5 overflow-x-auto scrollbar-hide py-2 px-1 items-center snap-x whitespace-nowrap scroll-smooth"
            >
              {loadingCategories ? (
                <div className="flex gap-3 py-1">
                  {[1, 2, 3, 4, 5].map((n) => (
                    <div key={n} className="h-10 w-36 bg-slate-200/60 rounded-full animate-pulse" />
                  ))}
                </div>
              ) : (
                activeSubCategories.map((subCat) => {
                  const IconComponent = subCat.icon;
                  const isActive = subCategorySlug.toLowerCase() === subCat.slug.toLowerCase();

                  return (
                    <button
                      key={subCat.id}
                      onClick={() => navigate(`/experts/${currentCategoryKey}/${subCat.slug}`)}
                      className={`
                        relative group/item flex items-center gap-2 px-4 py-2.5 rounded-full text-xs sm:text-sm font-semibold tracking-wide
                        transition-all duration-300 ease-out border shrink-0 snap-start cursor-pointer select-none
                        ${
                          isActive
                            ? subCat.activeClass
                            : `bg-white border-gray-200 text-gray-700 shadow-xs ${subCat.hoverClass} hover:shadow-md hover:-translate-y-0.5`
                        }
                      `}
                    >
                      <IconComponent 
                        className={`w-4 h-4 transition-transform duration-300 group-hover/item:scale-110 ${
                          isActive ? 'text-white' : 'text-gray-500 group-hover/item:text-current'
                        }`} 
                      />

                      <span>{subCat.label}</span>

                      {subCat.badge && (
                        <span 
                          className={`text-[9px] font-extrabold px-1.5 py-0.5 rounded-full uppercase tracking-wider ml-0.5 ${
                            isActive 
                              ? 'bg-white/20 text-white border border-white/30' 
                              : subCat.badge === 'Popular' 
                                ? 'bg-rose-100 text-rose-700 border border-rose-200' 
                                : 'bg-emerald-100 text-emerald-700 border border-emerald-200'
                          }`}
                        >
                          {subCat.badge}
                        </span>
                      )}
                    </button>
                  );
                })
              )}
            </div>

            {/* RIGHT ARROW BUTTON (Visible on PC hover) */}
            <button
              onClick={() => scroll('right')}
              className="hidden md:flex absolute right-0 top-1/2 -translate-y-1/2 z-20 w-8 h-8 items-center justify-center rounded-full bg-white/90 shadow-md border border-gray-200 text-gray-700 hover:bg-white hover:scale-110 opacity-0 group-hover:opacity-100 transition-all duration-200 cursor-pointer"
              title="Scroll Right"
            >
              <ChevronRight className="w-5 h-5" />
            </button>

          </div>

        </div>
      </div>
    </>
  );
};